// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 957 ? "routes" : chunkId) + "." + {"865":"04fff499","957":"2d545ba7"}[chunkId] + ".chunk.css";
};